import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import ModulEnum from 'src/enums/ModulEnum';
import { isVisible } from 'src/utils/formAuthHelper';

export interface IMenuItemProps extends MenuItemProps {
  authCode?: string;
  modul?: ModulEnum;
}

const MenuItem = (props: IMenuItemProps): JSX.Element => {
  const {  authCode, modul} = props;
  return(
    isVisible(authCode, modul) && (
    <MuiMenuItem {...props}/>
  ));
};

export default MenuItem;
